









































































































































































































































import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { Vue, Prop, Component } from 'vue-property-decorator'
import VueElementLoading from "vue-element-loading"
import popUp from "@/modules/budget/monitoring/input-forms/components/popUp.vue"
import { Entry, formatDecimal, formatPositiveDecimal, parseFormattedNumber } from './types/Entry'
import { Ax } from '@/utils'
import i18nService from "@/services/i18n"
import { cloneDeep } from 'lodash'
import { SupportMeasure } from './types/SupportMeasure'

const trPath = 'modules.budget_execution_monitoring.reports._app23'

@Component({
    components: {
        'loading': VueElementLoading,
        'pop-up': popUp,
    }
})
export default class Application23 extends Vue {

    // #region Props
    @Prop({
        required: true
    })
    private currForm!: any

    @Prop({
        required: true,
        default: false
    })
    private haveEditAccess!: boolean
    // #endregion

    // #region Data
    private year: number = this.currForm.year
    public loading = false
    public noteEntry: Entry | null = null
    public showReasonInput = false
    public showAddMeasureModal = false
    public showNoteModal = false
    public isAgreedForm = false
    public entries: Entry[] = []
    public supportMeasures: SupportMeasure[] = []
    get searchedSupportMeasures(): SupportMeasure[] {
        console.log(this.measureCodeSearch)
        if (!this.measureCodeSearch) {
            return this.supportMeasures
        }

        return this.supportMeasures.filter(it =>
            it.code.includes(this.measureCodeSearch)
            || it.nameRu.includes(this.measureCodeSearch)
            || it.nameKk.includes(this.measureCodeSearch)
        )
    }
    public allMeasuresActive = false
    public measureCodeSearch = ''
    
    public readonly tableFields: string[] = [
        'orderIndex',
        'supportMeasureName',
        'plannedSum',
        'issuedSum',
        'deviation',
        'note',
        'deletion',
    ] 

    public readonly supportMeasureTableFields: string[] = [
        'checkbox',
        'code',
        'name',
    ]

    get haveNotesForEachDeviation(): boolean {
        const unnotedDeviatedEntries = this.entries
            .filter(entry => entry.deviation !== 0 && (!entry.noteRu) && (!entry.noteKk))

        return unnotedDeviatedEntries.length === 0
    }

    get isInProgressForm() {
        return !this.isAgreedForm
    }

    get isSummaryForm() {
        return ['app19', 'app13cons', 'app17'].includes(this.currForm.form_code)
    }

    get isNonSummaryForm() {
        return !this.isSummaryForm
    }

    get nonPresentSupportMeasures(): SupportMeasure[] {
        return this.searchedSupportMeasures.filter(it => !this.isSupportAlreadyPresent(it.code))
    }

    get userId(): string {
        return this.$store.getters.user_uuid
    }
    // #endregion

    // #region Flash
    isFlashing = false
    flashTimeout: ReturnType<typeof setTimeout> | null = null

    triggerFlash() {
        if (this.flashTimeout) clearTimeout(this.flashTimeout)
        this.isFlashing = false

        // requestAnimationFrame ensures the class removal above is painted
        // before we re-add it, so re-clicking mid-flash restarts the animation
        requestAnimationFrame(() => {
        this.isFlashing = true
        this.flashTimeout = setTimeout(() => {
            this.isFlashing = false
        }, 1000)
        })
    }

    beforeUnmount() {
        if (this.flashTimeout) clearTimeout(this.flashTimeout)
    }
    // #endregion

    // #region LifeCycle
    private async created() {
        await this.loadEntries()
        await this.loadSupportMeasures()
        this.isAgreedForm = this.isStatusAgreed(this.currForm.status.status)
        this.$emit('onRegisterFacade', this)
    }
    // #endregion

    // #region Methods
    private setNote() {
        const entry = this.entries.find(it => it.id === this.noteEntry?.id)
        if (entry && this.noteEntry) {
            entry.noteRu = this.noteEntry.noteRu
            entry.noteKk = this.noteEntry.noteKk
        }
    }

    public onSetNote() {
        this.setNote()
        this.showNoteModal = false
    }

    public openNoteModal(entry: Entry) {
        if (!this.haveEditAccess) {
            return
        }

        this.noteEntry = cloneDeep(entry)
        this.showNoteModal = true
    }

    public async onAddNewMeasures() {
        const newEntries: Entry[] = this.nonPresentSupportMeasures
            .filter(it => it.isActive)
            .map((it, index) => {
                const mapped: Entry = new Entry(
                    this.entries.length + 1 + index,
                    null,
                    it.code,
                    it.nameRu,
                    it.nameKk,
                    0,
                    0,
                    null,
                    null,
                )
                return mapped
            })

        this.entries = this.entries.concat(newEntries)
        this.showAddMeasureModal = false
    }

    private async addMeasures() {
        type CreateApplication23Request = {
            form_id: number
            user_id: string
            entries: CreateApplication23Entry[] 
        }
        type CreateApplication23Entry = {
            support_measure_code: string
            plan_amount: number
            issued_amount: number
            note_ru: string | null
            note_kk: string | null
        }

        try {
            this.loading = true
            const entries: CreateApplication23Entry[] = this.nonPresentSupportMeasures
                .filter(it => it.isActive)
                .map(it => {
                    const mapped: CreateApplication23Entry = {
                        support_measure_code: it.code,
                        plan_amount: 0,
                        issued_amount: 0,
                        note_ru: null,
                        note_kk: null,
                    }
                    return mapped
                })
            const requestBody: CreateApplication23Request = {
                form_id: this.currForm.id,
                user_id: this.userId,
                entries: entries,
            }

            const response = await fetch('/api-py/application/input-forms/23', {
                method: 'POST',
                body: JSON.stringify(requestBody),
            })

            if (!response.ok) {
                const errorMessage = await response.json().catch(() => null)
                throw new Error(errorMessage || `Request failed with status ${response.status}`)
            }
            
            this.makeToast('success', this.$t('modules.common.saving'), this.$t('modules.common.data_saved_successfully'))
            this.showAddMeasureModal = false
        } catch (error) {
            console.error('Failed to load form data:', error)
            this.makeToast('danger', this.tr('error'), error)
        } finally {
            this.loading = false
        }
    }

    private async editEntries() {
        type EditApplication23Request = {
            user_id: string
            form_id: number
            entries: EditApplication23Entry[] 
        }
        type EditApplication23Entry = {
            id: number | null
            measure_code: string
            plan_amount: number
            issued_amount: number
            note_ru: string | null
            note_kk: string | null
        }

        try {
            this.loading = true
            const entries: EditApplication23Entry[] = this.entries.map(it => {
                const mapped: EditApplication23Entry = {
                        id: it.id,
                        measure_code: it.supportMeasureCode,
                        plan_amount: it.plannedSum ?? 0,
                        issued_amount: it.issuedSum ?? 0,
                        note_ru: it.noteRu,
                        note_kk: it.noteKk,
                    }
                    return mapped
                })
            const requestBody: EditApplication23Request = {
                form_id: this.currForm.id,
                user_id: this.userId,
                entries: entries,
            }

            const response = await fetch('/api-py/application/input-forms/23', {
                method: 'PUT',
                body: JSON.stringify(requestBody),
            })

            if (!response.ok) {
                const errorMessage = await response.json().catch(() => null)
                throw new Error(errorMessage || `Request failed with status ${response.status}`)
            }
            
            this.makeToast('success', this.$t('modules.common.saving'), this.$t('modules.common.data_saved_successfully'))
        } catch (error) {
            console.error('Failed to load form data:', error)
            this.makeToast('danger', this.tr('error'), error)
        } finally {
            this.loading = false
        }
    }

    public async onDeleteButton(entry: Entry) {
        if (!this.haveEditAccess) {
            return
        }

        const confirmed = await this.$bvModal.msgBoxConfirm(
            this.tr('delete_chosen_row'),
            {
                title: String(this.$t('modules.common.confirmation')),
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: String(this.$t('modules.common.delete')),
                cancelTitle: String(this.$t('modules.common.cancel')),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }
        )

        if (confirmed) {
            if (entry.id != null) {
                await this.deleteEntry(entry.id)
                await this.loadEntries()
            } else {
                this.entries = this.entries.filter(it => it.orderIndex !== entry.orderIndex)
            }
        }
    }

    private async deleteEntry(entryId: number) {
        try {
            this.loading = true

            const response = await fetch(`/api-py/application/input-forms/23/${entryId}`, {
                method: 'DELETE'
            })

            if (!response.ok) {
                const errorMessage = await response.json().catch(() => null)
                throw new Error(errorMessage || `Request failed with status ${response.status}`)
            }
            
            this.makeToast('success', this.$t('modules.common.deletion'), this.$t('modules.common.data_deleted'))
        } catch (error) {
            console.error('Failed to load form data:', error)
            this.makeToast('danger', this.tr('error'), error)
        } finally {
            this.loading = false
        }
    }

    public isSupportAlreadyPresent(measureCode: string): boolean {
        return Boolean(this.entries.find(it => it.supportMeasureCode === measureCode))
    }

    public toggleAllMeasuresActive(value: boolean) {
        this.nonPresentSupportMeasures
            .filter(it => !this.isSupportAlreadyPresent(it.code))
            .forEach(it => it.isActive = value)
    }

    public onIsActiveInput() {
        let isAllActive = true
        this.nonPresentSupportMeasures.forEach(it => {
            if (!it.isActive) {
                isAllActive = false
            }
        })
        this.allMeasuresActive = isAllActive
    }

    public onNumberInput(value: string | null, entry: Entry, field: keyof Entry) {
        const parsed = value == null ? null : parseFormattedNumber(value)
        // @ts-ignore
        entry[field] = parsed
    }

    public openAddMeasureModal() {
        this.showAddMeasureModal = true
    }

    public tr(key: string): string {
        const text = String(this.$t(`${trPath}.${key}`))
        return text
    }

    public formatDecimal = formatDecimal
    public formatPositiveDecimal = formatPositiveDecimal

    private isStatusAgreed(status: number) {
        return ![73, 27].includes(status)
    }

    public calculateTotal(field: keyof Entry) {
        let sum = 0
        this.entries.forEach(it => {
            if (typeof it[field] === 'number') {
                // @ts-ignore
                sum += Math.round(it[field] * 100)
            } else if (typeof it[field] === 'string') {
                // @ts-ignore
                sum += Math.round(parseFormattedNumber(it[field]) * 100)
            }
        })
        return sum / 100
    }

    private async fetchEntries(formId: number): Promise<Entry[]> {
        let entries: Entry[] = []

        try {
            this.loading = true

            const params = new URLSearchParams()
            params.set('form_id', formId.toString())
            const response = await fetch(`/api-py/application/input-forms/23?${params}`)
            if (!response.ok) {
                const errorMessage = await response.json().catch(() => null)
                throw new Error(errorMessage || `Request failed with status ${response.status}`)
            }
            const responseItems: any[] = await response.json()

            entries = responseItems.map((it, index) => {
                return new Entry(
                    index + 1,
                    it.id,
                    it.support_measure_code,
                    it.name_ru || '',
                    it.name_kk || '',
                    it.plan_amount,
                    it.issued_amount,
                    it.note_ru,
                    it.note_kk,
                )
            })
        } catch (error) {
            console.error('Failed to load form data:', error)
            this.makeToast('danger', this.tr('error'), error)
        } finally {
            this.loading = false
        }

        return entries
    }

    private async fetchSupportMeasures(date: string): Promise<SupportMeasure[]> {
        let entries: SupportMeasure[] = []

        try {
            this.loading = true

            const params = new URLSearchParams()
            params.set('date', date)
            const response = await fetch(`/api-py/application/input-forms/support-measures?${params}`)
            if (!response.ok) {
                const errorMessage = await response.json().catch(() => null)
                throw new Error(errorMessage || `Request failed with status ${response.status}`)
            }
            const responseItems: any[] = await response.json()

            entries = responseItems.map((it) => {
                return new SupportMeasure(
                    it.id,
                    it.code,
                    it.name_ru,
                    it.name_kk,
                )
            })
        } catch (error) {
            console.error('Failed to load form data:', error)
            this.makeToast('danger', this.tr('error'), error)
        } finally {
            this.loading = false
        }

        return entries
    }

    private async loadEntries() {
        const entries = await this.fetchEntries(this.currForm.id)
        this.entries = entries
    }

    private async loadSupportMeasures() {
        const supportMeasures = await this.fetchSupportMeasures(`${this.year}-01-01`)
        this.supportMeasures = supportMeasures
    }


    public async saveData() {
        if (this.isAgreedForm) {
            this.makeToast(
                'info',
                this.tr('message'),
                this.tr('blocked_edit.in_progress_form'),
            )
            return
        }

        if (!this.haveNotesForEachDeviation) {
            this.triggerFlash()
        }

        await this.editEntries()
    }

    public async onBack() {
        if (this.haveNotesForEachDeviation) {
            return true
        }

        const confirmed = await this.$bvModal.msgBoxConfirm(
            this.tr('unfulfilled_data'),
            {
                title: this.tr('attention'),
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: this.tr('leave'),
                cancelTitle: this.tr('stay'),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }
        )

        return confirmed
    }

    public async onReasonBack() {
        // Assign newly loaded reasons to existing entries
        // const newReasonEntries = await this.fetchEntries(
        //     this.currForm.form_code,
        //     this.year,
        //     this.currForm.region,
        //     this.currForm.abp || null
        // )

        // const reasonsMap: Map<number, Reason[]> = new Map()
        // newReasonEntries.forEach(entry => {
        //     if (entry.id && entry.reasons.length > 0) {
        //         reasonsMap.set(entry.id, entry.reasons)
        //     }
        // })

        // this.entries = this.entries.map(entry => {
        //     entry.reasons = reasonsMap.get(entry.id!!) ?? []
        //     return entry
        // })

        // this.showReasonInput = false
        // this.$emit('onCloseReasons')
    }

    public downloadReport() {
        this.loading = true
        const that = this
        
        try {
            this.makeToast('info', this.$t('modules.common.attention'), this.$t('modules.budget_execution_monitoring.reports.app_9.warn_download'))
            
            const params = new URLSearchParams()
            params.set('form_id', this.currForm.id)
            params.set('locale', i18nService.locale)
            Ax(
                {
                    url: `/api-py/application/input-forms/23/export?${params}`,
                    method: 'get',
                    responseType: 'blob',
                },
                (data: any) => {
                    const url = window.URL.createObjectURL(new Blob([data]))
                    const link = document.createElement('a')
                    link.href = url
                    const formName = this.tr('forms.app23')
                    link.setAttribute('download', formName + '.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    that.loading = false
                },
                (error) => {
                    that.loading = false
                    this.makeToast('danger', this.tr('download_error'), error.toString())
                }
            )
        } catch (error) {
            that.loading = false
            this.makeToast('danger', this.$t('modules.common.warning'), this.$t('modules.budget_execution_monitoring.reports.app_9.warn_filter'))
        }
    }

    public get downloadList() {
        const reportList: any[] = [{
            fn: this.downloadReport,
            args: [],
            name: this.tr(`forms.${this.currForm.form_code}`),
            idx: 0
        }]
        return reportList
    }

    private makeToast(variant: 'success' | 'danger' | 'warning' | 'info', title: any, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }
    // #endregion
}
